import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";

const SpaBookingSuccess = (props) => {

	const { t } = props

	return (
		<>

<div>
		 
		<section class="widgets spa-listing spa-details">



		<div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl &&
                    <div class="widget-header-img">
                        <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                    </div>
                }
                <div class="widget-header-title">{t(`spaBooking.headingSuccess`)}</div>
                <div class="widget-header-subtitle">{t(`spaBooking.sub_headingSuccess`)}</div>
            </div>


		{/* <div>
			<h1>Your Appointment Id</h1>
			<p>{props.successResponse.payload.data.appointmentId}</p>
		</div> */}

		





		<form>
                       
                
                      <div class="form-row spa-summary">
                        <p class="heading">Details</p>
                        <label>
						Appointment Id <span>{props.successResponse.payload.data.appointmentId}</span>
                        </label>
						</div>
						</form>


















		 



			<div class="widgets">
				<div class="row margin-bottom-2">
					<div class="row">
						<div class="col">
							<div class="detail-body stay-body">
								<div class="stay-info-details">
									<div class="stay-info-body">
										<p>Thank you for choosing the {props.serviceData.name} Spa at Viceroy Sugar Beach. We are delighted to confirm your upcoming spa treatment.</p>
										<p>Please arrive at least 15 minutes prior to your appointment time to allow for a relaxed check-in and to enjoy our pre-treatment amenities.</p>
										<p>If you need to reschedule or cancel your appointment, please contact us at least <strong>24 hours</strong> in advance to avoid cancellation fees.</p>
										<p>We look forward to providing you with a rejuvenating spa experience surrounded by the serene beauty of St. Lucia.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="form-controls">
							<button>Close</button>
						</div>
					</div>
				</div>
			</div>
		</section>
		
		<script type="text/javascript" src="js/jquery-3.3.1.min.js"></script>
		<script type="text/javascript" src="js/framework.js"></script>
	  
	</div>
		
		</>
	)

}

const mapStateToProps = state => {
	return {
		installedAppVersion: state.store.installedAppVersion,
		installedAppBuildNo: state.store.installedAppBuildNo,
		currentWidgetObj: state.store.sideNavBar.currentWidget,

	}
}

export default connect(mapStateToProps, {})(withTranslation('translations')(SpaBookingSuccess));